'use client';

import React, { useEffect, useState } from 'react';

import { MILLION_CATCHES } from '../../../constants/constants';

import { DownloadAppContent } from './components/DownloadAppContent';
import { getRandomInteger } from '../../../helpers/number';

export const DownloadAppVerticalCTA = () => {
  const [randomAddCopyVarient, setRandomAddCopyVarient] = useState(0);

  useEffect(() => {
    setRandomAddCopyVarient(getRandomInteger(1, 2));
  }, []);

  switch (randomAddCopyVarient) {
    case 1:
      return (
        <DownloadAppContent
          headingText="Download the Fishbrain app"
          subHeadingText={`Discover ${MILLION_CATCHES} million fishing spots, top baits, and more`}
        />
      );
    case 2:
      return <DownloadAppContent />;
    default:
      return <DownloadAppContent isLoading />;
  }
};
